export const cacheTags = {
  BrandAutomationRules: 'BrandAutomationRules',
  BrandAutomationRule: 'BrandAutomationRule',
  UserConfigs: 'UserConfigs',
  ResourceSystemSettings: 'ResourceSystemSettings',
  DevToolsJobs: 'DevToolsJobs',
  DevToolsDbServices: 'DevToolsDbServices',
  DevToolsDbServiceTables: 'DevToolsDbServiceTables',
  ReleaseNote: 'ReleaseNote',
  AgSentData: 'AgSentData',
  Partners: 'Partners',
  LatestReleaseNote: 'LatestReleaseNote',
  Brands: 'Brands',
  Users: 'Users',
  User: 'User',
  IpWhitelist: 'IpWhitelist',
  Permissions: 'Permissions',
  PermissionGroups: 'PermissionGroups',
  AllPermissionGroups: 'AllPermissionGroups',
  PermissionGroup: 'PermissionGroup',
  Requests: 'Requests',
  Request: 'Request',
  UserBrandAccesses: 'UserBrandAccesses',
  UserPartnerAccesses: 'UserPartnerAccesses',
  ResourcePermissionGroups: 'ResourcePermissionGroups',
  ResourceUsersByBrands: 'ResourceUsersByBrands',
  ResourceUsers: 'ResourceUsers',
  ResourceUsersByPartner: 'ResourceUsersByPartner',
  ResourcePartner: 'ResourcePartner',
  ResourcePartnerTFAState: 'ResourcePartnerTFAState',
  ResourcePartnerAccesses: 'ResourcePartnerAccesses',
  Partner: 'Partner',
  SportBets: 'SportBets',
  CasinoBets: 'CasinoBets',
  PlayerSportBets: 'PlayerSportBets',
  PlayerCasinoBets: 'PlayerCasinoBets',
  TestPlayers: 'TestPlayers',
  TestPlayerUsers: 'TestPlayerUsers',
  Cashback: 'Cashback',
  CashbackPlayers: 'CashbackPlayers',
  CashbackIncludedPlayers: 'CashbackIncludedPlayers',
  CashbackStatistics: 'CashbackStatistics',
  PlayerCashbackPeriods: 'PlayerCashbackPeriods',
  PlayerAccountCashbackPeriods: 'PlayerAccountCashbackPeriods',
  CashbackPeriodsResource: 'CashbackPeriodsResource',
  CashbackV2: 'CashbackV2',
  CashbackV2Statistics: 'CashbackV2Statistics',
  CashbackV2Players: 'CashbackV2Players',
  CashbackV2IncludedPlayers: 'CashbackV2IncludedPlayers',
  Deposits: 'Deposits',
  Withdrawals: 'Withdrawals',
  PlayerDeposits: 'PlayerDeposits',
  PlayerWithdrawals: 'PlayerWithdrawals',
  DepositNotes: 'DepositNotes',
  WithdrawalNotes: 'WithdrawalNotes',
  DepositLogs: 'DepositLogs',
  WithdrawalLogs: 'WithdrawalLogs',
  DepositTags: 'DepositTags',
  WithdrawalTags: 'WithdrawalTags',
  UserLogs: 'UserLogs',
  PlayerLogs: 'PlayerLogs',
  EpisLogs: 'EpisLogs',
  UserManagementLogs: 'UserManagementLogs',
  DepositRefunds: 'DepositRefunds',
  EddVerification: 'EddVerification',
  TelegramSettings: 'TelegramSettings',
  GamificationList: 'GamificationList',
  Gamification: 'Gamification',
  SpinDistributions: 'SpinDistributions',
  SpinDistribution: 'SpinDistribution',
  PlayingParticipants: 'PlayingParticipants',
  PlayingParticipant: 'PlayingParticipant',
  Prize: 'Prize',
  Prizes: 'Prizes',
  Machine: 'Machine',
  Machines: 'Machines',
  GroupLimit: 'GroupLimit',
  MachineConfig: 'MachineConfig',
  MachineConfigs: 'MachineConfigs',
  PrizeContents: 'PrizeContents',
  PrizeContent: 'PrizeContent',
  ExchangeItems: 'ExchangeItems',
  ExchangeItem: 'ExchangeItem',
  SpinDistributionContents: 'SpinDistributionContents',
  SpinDistributionContent: 'SpinDistributionContent',
  PrizeContentConnectedPrizes: 'PrizeContentConnectedPrizes',
  GamificationContents: 'GamificationContents',
  GamificationContent: 'GamificationContent',
  MachineContents: 'MachineContents',
  MachineContent: 'MachineContent',
  MachineDetails: 'MachineDetails',
  GamificationPreviewValidationState: 'GamificationPreviewValidationState',
  MaterialPrizesReport: 'MaterialPrizesReport',
  PrivateParticipantsReport: 'PrivateParticipantsReport',
  SpinAdjustmentsReport: 'SpinAdjustmentsReport',
  PlayerSpinsReport: 'PlayerSpinsReport',
  PlayerAttachments: 'PlayerAttachments',
  KycReport: 'KycReport',
  BrandVerificationDocumentTypes: 'BrandVerificationDocumentTypes',
  ThirdPartyKycServices: 'ThirdPartyKycServices',
  ThirdPartyAffiliateServices: 'ThirdPartyAffiliateServices',
  ThirdPartyServices: 'ThirdPartyServices',
  SentNotifications: 'SentNotifications',
  ScheduledNotifications: 'ScheduledNotifications',
  SystemTemplate: 'SystemTemplate',
  SystemTemplates: 'SystemTemplates',
  InboxMessage: 'InboxMessage',
  PlayerInboxMessages: 'PlayerInboxMessages',
  PlayerNotificationPreferences: 'PlayerNotificationPreferences',
  PlayersBulkStatusUpdateHistory: 'PlayersBulkStatusUpdateHistory',
  BulkStatusUpdatedPlayers: 'BulkStatusUpdatedPlayers',
  ProvidersBlockedAccessesHistory: 'ProvidersBlockedAccessesHistory',
  PaymentMethodsBlockedAccessesHistory: 'PaymentMethodsBlockedAccessesHistory',
  BrandPaymentSettings: 'BrandPaymentSettings',
  PlayerAutoDeposit: 'PlayerAutoDeposit',
  DashboardWidgets: 'DashboardWidgets',
  Dashboards: 'Dashboards',
  ThirdPartyLiveChatSolutionServices: 'ThirdPartyLiveChatSolutionServices',
  ThirdPartyGamificationServices: 'ThirdPartyGamificationServices',
  ThirdPartyCrmServices: 'ThirdPartyCrmServices',
  ThirdPartyAnalyticsServices: 'ThirdPartyAnalyticsServices',
  ThirdPartyRetailSolutionServices: 'ThirdPartyRetailSolutionServices',
  ThirdPartyArtificialIntelligenceServices: 'ThirdPartyArtificialIntelligenceServices',
  ThirdPartyAgSolutionServices: 'ThirdPartyAgSolutionServices',
  ThirdPartyAuthenticationServices: 'ThirdPartyAuthenticationServices',
  ThirdPartyTrustlyServicePreferences: 'ThirdPartyTrustlyServicePreferences',
  ThirdPartyThunderBiteCampaigns: 'ThirdPartyThunderBiteCampaigns',
  ThirdPartyDigitainAgPaymentLimits: 'ThirdPartyDigitainAgPaymentLimits',
  ThirdPartyCustomScripts: 'ThirdPartyCustomScripts',
  Units: 'Units',
  Referrals: 'Referrals',
  Referral: 'Referral',
  ReferralStatistics: 'ReferralStatistics',
  ReferralParticipants: 'ReferralParticipants',
  ReferralAllParticipants: 'ReferralAllParticipants',
  SmsSettings: 'SmsSettings',
  SmtpSettings: 'SmtpSettings',
  EmailContacts: 'EmailContacts',
  Preferences: 'Preferences',
  WhatsApp: 'WhatsApp',
  MagicLinkSettings: 'MagicLinkSettings',
  BrandReferralConfig: 'BrandReferralConfig',
  BonusActivationConfig: 'BonusActivationConfig',
  NraLogs: 'NraLogs',
  ExportCenter: 'ExportCenter',
  BrandCategoryAgeBasedLimitConfigs: 'BrandCategoryAgeBasedLimitConfigs',
  PartnerGroups: 'PartnerGroups',
  PendingDocumentVerifications: 'PendingDocumentVerifications',
  BrandBonusSettings: 'BrandBonusSettings',
  SelfieKycLogs: 'SelfieKycLogs',
} as const;
